import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CokyTableComponent } from 'src/app/modules/shared/imports/components/table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { QueriesService } from 'src/app/core/services/queries.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { RequestsService } from 'src/app/core/services/requests.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { CokyHelperDialogComponent } from './components/dialog/dialog.component';
import { CokyHelperSnackbarComponent } from './components/snackbar/snackbar.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTreeModule } from '@angular/material/tree';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { CdkTreeModule } from '@angular/cdk/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSortModule } from '@angular/material/sort';
import {MatRadioModule} from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    CokyTableComponent,
    CokyHelperDialogComponent,
    CokyHelperSnackbarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTreeModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatTabsModule,
    CdkTreeModule,
    DragDropModule,
    MatProgressBarModule,
    MatSortModule,
    MatRadioModule,
    MatChipsModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CokyTableComponent,
    CokyHelperDialogComponent,
    CokyHelperSnackbarComponent,
    NgbModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTreeModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatTabsModule,
    CdkTreeModule,
    DragDropModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    MatSortModule,
    MatRadioModule,
    MatChipsModule,


  ],
  providers: [
    HelpersService,
    NotificationHelper,
    RequestsService,
    QueriesService,
    MenuService,
    MatDatepickerModule,
  ],
})
export class ImportsModule {}
